import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import SearchInput from '../SearchInput';
import SearchResultList from '../SearchResultList';
import Loading from '../../../LoadingComponent/LoadingComponent';
import SearchIntro from '../SearchIntro/SearchIntro';
import NoSearchResults from '../NoSearchResults/NoSearchResults';
import { chooseOrderingSystemForSelectedAction, emailRegex, phoneRegex } from '../../../../util';
import { trackOrderSearchQuerySubmitted, trackOrderSearchSetAction } from '../../../../analytics/searchEventAnalytics';
import * as searchActions from '../../../../constants/searchActions';
import * as searchTypes from '../../../../constants/searchTypes';
import {
  selectOrder,
  selectOrderingSystem,
  setSearchOrdersAction,
  setSelectedTicketOrderNumber,
  setSelectedMultiDomain,
  setSimplrOrderSelectedMultiDomains,
} from '../../../../actions/tools/OrdersSearchActions';
import {
  BlueSection,
  ResultsBox,
  SearchAndResults,
  SearchOrdersBox,
  SearchOrdersPageWrapper,
  SearchPageSelect,
  LoadingContainer,
} from '../Search.styles';
import { displayPopupMessageInformation } from '../searchUtils';
import { extractFirstMessage, extractSelectedTicketFromState } from '../../../../extractFromState';
import {
  getIsAmazonInstalled,
  chooseDefaultSearchValue,
  getIsCustomSellerInstalled,
  getDefaultSearchValueType,
  getSelectedOrderSearchAction,
  isIntegrationValueAvailable,
  getIsZendeskShopSelected,
  getOrdersSearchProperties,
  getOrderingSystem,
  getIsShopifyInstalled,
  getIsSimplrOrderInstalled,
  getIsRbiInstalled,
  getRbiDomains,
  getIsSalesforceOrderManagerEnabled,
  getSimplrorderDomains,
  getSelectedMultiDomain,
  getSelectedSimplrOrderMultiDomains,
  getSimplrorderConfigs,
} from '../../../../selectors/tools';
import {
  shopifyGetAndSelectOrder,
  shopifyGetCustomerOrders,
  shopifyGetOrder,
} from '../../../../actions/tools/ShopifyActions';
import { getCustomerOrdersFromZendesk } from '../../../../actions/tools/ZendeskActions';
import { amazonGetOrderByNumber, amazonGetOrdersByEmail } from '../../../../actions/tools/AmazonActions';
import { simplrOrderGetOrdersById, simplrOrderGetOrders } from '../../../../actions/tools/SimplrOrderActions';
import { setLoading } from '../../../../actions';
import { getOrderByCustomSellerEmail } from '../../../../actions/tools/CustomSellerActions';
import { FullColoredButton } from '../../../common/buttonsComponents';
import { searchRbiOrdersByEmail, searchRbiOrdersById } from 'actions/tools/RBIActions';
import { searchSalesforceOrdersByEmail, searchSalesforceOrdersById } from 'actions/tools/SalesforceActions';
import { Table } from 'components/common/tableElements';
import SearchResultHeader from '../SearchResultHeader';
import { showErrorMessage } from '../../../../util/errorPopupUtil';
import { ErrorStrings } from '../../../../constants/fixedMessages';
import * as limits from '../../../../constants/limits';
import { handleError } from 'services/ErrorService/ErrorService';

export class SearchOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingOrder: !!props.fetchingOrder,
      showSimplrOrdersMultiShopSelect: true,
    };
  }

  async componentDidMount() {
    if (this.props.orderingSystem === 'simplrOrder') {
      const autoSelected = await this.autoSelectSimplrOrderDomains();
      if (autoSelected && this.props.isIntegrationValueAvailable) {
        await this.updateSearchList();
      }
    } else if (this.props.isIntegrationValueAvailable) {
      await this.updateSearchList();
    }
  }

  handleActionSelection = async (event) => {
    const selectedSearchAction = event.target.value;
    trackOrderSearchSetAction({ action: selectedSearchAction });
    this.props.selectOrderingSystem(await chooseOrderingSystemForSelectedAction(selectedSearchAction));
    this.props.setSearchOrdersAction(selectedSearchAction);

    if (this.props.orderingSystem === 'simplrOrder') {
      const autoSelected = await this.autoSelectSimplrOrderDomains();
      if (autoSelected && this.props.defaultSearchValue) {
        await this.updateSearchList();
      }
    } else if (this.props.defaultSearchValue) {
      await this.updateSearchList();
    }
  };

  async updateSearchList() {
    this.props.selectOrderingSystem(chooseOrderingSystemForSelectedAction(this.props.selectedSearchAction));
    await this.handleSearchOrders(this.props.defaultSearchValue);
  }

  getSimplrOrderMultiDomainsSearchList = () => {
    return (this.props.simplrOrderMultiDomains && this.props.simplrOrderMultiDomains.join(',')) || '';
  };

  handleSearchOrders = (searchValue) => {
    searchValue = searchValue || '';
    const searchOrderShops = this.props.ordersSearch.searchOrderShops;
    const singleShopSelection = searchOrderShops && searchOrderShops[0];
    const { selectedTicket, multiDomain } = this.props;
    const simplrOrderMultiDomains = this.getSimplrOrderMultiDomainsSearchList();
    const { simplrAccountPtrId } = selectedTicket;
    const action = this.props.selectedSearchAction;

    trackOrderSearchQuerySubmitted({ action, searchQuery: searchValue.trim() });

    let query = null;
    switch (action) {
      case searchActions.SHOPIFY_ORDER_NUMBER:
        if (!searchValue || !searchValue.trim()) {
          displayPopupMessageInformation('Please enter an order number');
          break;
        }
        query = {
          name: searchValue.trim(),
          status: 'any',
        };
        this.props.setLoading(true);

        return this.props.shopifyGetOrder(query, searchOrderShops);
      case searchActions.SHOPIFY_EMAIL:
        if (!emailRegex.test(searchValue)) {
          displayPopupMessageInformation('Please enter a valid email address');
          break;
        }
        query = {
          status: 'any',
          email: searchValue.trim(),
        };
        this.props.setLoading(true);

        return this.props.shopifyGetCustomerOrders(query, searchOrderShops);
      case searchActions.SHOPIFY_PHONE_NUMBER:
        // remove non-digit characters from phone number prior to regex check
        searchValue = searchValue.replace(/\D/g, '');

        if (!/^[0-9]{11}$/.test(searchValue)) {
          displayPopupMessageInformation('Phone number must be 11 digits, i.e. "18001234567"');
          break;
        }
        query = {
          query: `phone:${searchValue}`,
          status: 'any',
        };
        this.props.setLoading(true);

        return this.props.shopifyGetCustomerOrders(query, searchOrderShops);
      case searchActions.SHOPIFY_FULL_NAME:
        const spaceCharacter = ' ';
        const fullName = searchValue
          .trim()
          .split(spaceCharacter)
          .map((data) => data.trim())
          .filter((data) => !!data);
        const firstName = fullName[0];
        const lastName = fullName[1];
        if (fullName.length !== 2 || !firstName || !lastName) {
          displayPopupMessageInformation(`Please enter a full name in the format 'firstname lastname'`);
          break;
        }
        const queryParams = `first_name:${firstName} last_name:${lastName}`;
        query = {
          query: queryParams,
          status: 'any',
        };
        this.props.setLoading(true);

        return this.props.shopifyGetCustomerOrders(query, searchOrderShops);
      case searchActions.AMAZON_ORDER_NUMBER:
        if (!searchValue || !searchValue.trim()) {
          displayPopupMessageInformation('Please enter an order number');
          break;
        }
        this.props.setLoading(true);

        return this.props.amazonGetOrderByNumber(simplrAccountPtrId, searchValue.trim());
      case searchActions.AMAZON_EMAIL:
        if (!emailRegex.test(searchValue)) {
          displayPopupMessageInformation('Please enter a valid email address');
          break;
        }
        this.props.setLoading(true);

        return this.props.amazonGetOrdersByEmail(simplrAccountPtrId, searchValue.trim());
      case searchActions.ZENDESK_EBAY_USERNAME:
        if (!searchValue || !searchValue.trim()) {
          displayPopupMessageInformation('Please enter an ebay username');
          break;
        }
        query = {
          searchBy: 'ebay_username',
          searchValue: searchValue.trim(),
        };
        this.props.setLoading(true);

        return this.props.getCustomerOrdersFromZendesk(singleShopSelection, query);
      case searchActions.ZENDESK_FULL_NAME:
        if (!searchValue || !searchValue.trim()) {
          displayPopupMessageInformation("Please enter user's full name");
          break;
        }
        query = {
          searchValue: searchValue.trim(),
        };
        this.props.setLoading(true);

        return this.props.getCustomerOrdersFromZendesk(singleShopSelection, query);
      case searchActions.ZENDESK_ORDER_NUMBER:
        if (!searchValue || !searchValue.trim()) {
          displayPopupMessageInformation('Please enter an order id');
          break;
        }
        query = {
          searchBy: 'latest_order_id',
          searchValue: searchValue.trim(),
        };
        this.props.setLoading(true);

        return this.props.getCustomerOrdersFromZendesk(singleShopSelection, query);
      case searchActions.ZENDESK_EMAIL:
        if (!emailRegex.test(searchValue)) {
          displayPopupMessageInformation('Please enter a valid email address');
          break;
        }
        query = {
          searchBy: 'email',
          searchValue: searchValue.trim(),
        };
        this.props.setLoading(true);

        return this.props.getCustomerOrdersFromZendesk(singleShopSelection, query);
      case searchActions.CUSTOM_SELLER_EMAIL:
        if (!emailRegex.test(searchValue)) {
          displayPopupMessageInformation('Please enter a valid email address');
          break;
        }
        this.props.setLoading(true);

        return this.props.getOrderByCustomSellerEmail(simplrAccountPtrId, searchValue);
      case searchActions.SIMPLR_ORDER_ID:
        if (!searchValue || !searchValue.trim()) {
          displayPopupMessageInformation('Please enter an order number');
          break;
        }

        query = {
          domains: simplrOrderMultiDomains,
          orderId: searchValue.trim(),
          status: 'any',
        };
        this.props.setLoading(true);

        return this.props.simplrOrderGetOrdersById(simplrAccountPtrId, query);
      case searchActions.SIMPLR_ORDER_EMAIL:
        if (!emailRegex.test(searchValue)) {
          displayPopupMessageInformation('Please enter a valid email address');
          break;
        }
        query = {
          domains: simplrOrderMultiDomains,
          customerEmail: searchValue.trim(),
        };
        this.props.setLoading(true);

        return this.props.simplrOrderGetOrders(simplrAccountPtrId, query);
      case searchActions.SIMPLR_ORDER_PHONE_NUMBER:
        if (!phoneRegex.test(searchValue)) {
          displayPopupMessageInformation('Please enter a valid phone number');
          break;
        }
        query = {
          domains: simplrOrderMultiDomains,
          customerPhone: searchValue.trim(),
        };
        this.props.setLoading(true);

        return this.props.simplrOrderGetOrders(simplrAccountPtrId, query);
      case searchActions.SIMPLR_ORDER_CUSTOMER_NAME:
        if (!searchValue || !searchValue.trim()) {
          displayPopupMessageInformation('Please enter a name');
          break;
        }
        query = {
          domains: simplrOrderMultiDomains,
          customerName: searchValue.trim(),
        };
        this.props.setLoading(true);

        return this.props.simplrOrderGetOrders(simplrAccountPtrId, query);
      case searchActions.SIMPLR_ORDER_CUSTOMER_ID:
        if (!searchValue || !searchValue.trim()) {
          displayPopupMessageInformation('Please enter an id');
          break;
        }
        query = {
          domains: simplrOrderMultiDomains,
          customerId: searchValue.trim(),
        };
        this.props.setLoading(true);

        return this.props.simplrOrderGetOrders(simplrAccountPtrId, query);

      case searchActions.RBI_ID:
        this.props.setLoading(true);

        return this.props.searchRbiOrdersById(simplrAccountPtrId, searchValue.trim(), multiDomain);
      case searchActions.RBI_EMAIL:
        if (!emailRegex.test(searchValue)) {
          displayPopupMessageInformation('Please enter a valid email address');
          break;
        }

        this.props.setLoading(true);

        return this.props.searchRbiOrdersByEmail(simplrAccountPtrId, searchValue.trim(), multiDomain);
      case searchActions.SALESFORCE_ORDER_EMAIL:
        if (!emailRegex.test(searchValue)) {
          displayPopupMessageInformation('Please enter a valid email address');
          break;
        }
        this.props.setLoading(true);

        return this.props.searchSalesforceOrdersByEmail(simplrAccountPtrId, searchValue.trim());
      case searchActions.SALESFORCE_ORDER_ID:
        this.props.setLoading(true);

        return this.props.searchSalesforceOrdersById(simplrAccountPtrId, searchValue.trim());
      default:
        handleError({ customMessage: `Unknown action: ${action}` });
    }
  };

  // TODO - refactor this so that shopify page state is cleared only for shopify orders
  orderClickHandler = async (event, order) => {
    event.preventDefault();
    this.props.selectOrder(order);
    this.props.setSelectedTicketOrderNumber(order.name);
  };

  orderClickHandlerWithSpinner = async (fetchFunction) => {
    this.setState({ fetchingOrder: true });
    try {
      await fetchFunction();
    } catch (error) {
      this.setState({ fetchingOrder: false });
    }
  };

  shopifyOrderClickHandler = async (order) => {
    await this.orderClickHandlerWithSpinner(() => {
      this.props.shopifyGetAndSelectOrder(order['id']);
      this.props.setSelectedTicketOrderNumber(order['name']);
    });
  };

  rbiOrderClickHandler = (order) => {
    this.props.selectOrder(order);
  };

  salesforceClickHandler = (order) => {
    this.props.selectOrder(order);
  };

  selectClickHandler = () => {
    switch (this.props.orderingSystem) {
      case 'shopify':
        return this.shopifyOrderClickHandler;
      case 'amazon':
      case 'customSeller':
        return this.orderClickHandler;
      case 'custom_rbi':
        return this.rbiOrderClickHandler;
      case 'salesforce':
        return this.salesforceClickHandler;
      default:
        return this.orderClickHandler;
    }
  };

  autoSelectSimplrOrderDomains = async () => {
    const { selectedTicket, simplrorderDomains, simplrorderConfigs } = this.props;

    if (!selectedTicket || !simplrorderConfigs || !Array.isArray(simplrorderDomains) || !simplrorderDomains.length) {
      this.setState({ showSimplrOrdersMultiShopSelect: true });
      showErrorMessage(ErrorStrings.SIMPLR_ORDER_AUTO_SELECT_FAILED);

      return false;
    }

    const ticketBrand = selectedTicket.brand;
    const domains = [];

    simplrorderDomains.forEach((domain) => {
      const domainConfigs = simplrorderConfigs[domain];
      const domainBrands = domainConfigs && domainConfigs.brands;
      if (!ticketBrand || !Array.isArray(domainBrands) || !domainBrands.length || domainBrands.includes(ticketBrand)) {
        domains.push(domain);
      }
    });

    /**
     * TODO: Use componentDidUpdate and remove the `await` keyword below (setSimplrOrderSelectedMultiDomains).
     * The below action is NOT async. We use `await` to ensure that the code below it
     * is executed after prop changes, but this is tech debt.
     */
    if (!domains.length || domains.length > limits.MAX_AUTO_SEARCH_STORES_COUNT) {
      await this.props.setSimplrOrderSelectedMultiDomains([simplrorderDomains[0]]);
      this.setState({ showSimplrOrdersMultiShopSelect: true });

      return true;
    }

    await this.props.setSimplrOrderSelectedMultiDomains(domains);
    this.setState({ showSimplrOrdersMultiShopSelect: false });

    return true;
  };

  showMultiShopSelect() {
    switch (this.props.orderingSystem) {
      case 'simplrOrder':
        return this.state.showSimplrOrdersMultiShopSelect;
      case 'custom_rbi':
        return this.props.isRbiInstalled && (this.props.rbiDomains || []).length > 1;
      default:
        return false;
    }
  }

  getMultiShopSelect() {
    const multiShop = {
      simplrOrder: () => {
        return this.props.simplrorderDomains.map((domain) => ({
          name: domain.toUpperCase(),
          value: domain,
        }));
      },
      custom_rbi: () => (this.props.rbiDomains || []).map((domain) => ({ name: domain, value: domain })),
    }[this.props.orderingSystem];

    const result = multiShop && multiShop();

    return result || [];
  }

  handleDomainSelection = (event) => {
    if (!event || !event.target) {
      return;
    }
    event.preventDefault();

    switch (this.props.orderingSystem) {
      case 'simplrOrder':
        this.props.setSimplrOrderSelectedMultiDomains([event.target.value]);
        break;
      default:
        this.props.setSelectedMultiDomain(event.target.value);
        break;
    }
  };

  getSelectOptions() {
    const {
      selectedSearchAction,
      isShopifyInstalled,
      isAmazonInstalled,
      isRbiInstalled,
      isSalesforceOrderManagerEnabled,
      isCustomSellerInstalled,
      isZendeskShopSelected,
      isSimplrOrderInstalled,
    } = this.props;

    return (
      <SearchPageSelect onChange={this.handleActionSelection} value={selectedSearchAction}>
        {isShopifyInstalled &&
          !isZendeskShopSelected && [
            <option key={searchActions.SHOPIFY_EMAIL} value={searchActions.SHOPIFY_EMAIL}>
              Get shopify orders by email
            </option>,
            <option
              key={searchActions.SHOPIFY_ORDER_NUMBER}
              value={searchActions.SHOPIFY_ORDER_NUMBER}
              disabled={isZendeskShopSelected}
            >
              Get shopify order by number
            </option>,
            <option
              key={searchActions.SHOPIFY_PHONE_NUMBER}
              value={searchActions.SHOPIFY_PHONE_NUMBER}
              disabled={isZendeskShopSelected}
            >
              Get shopify orders by phone number
            </option>,
            <option
              key={searchActions.SHOPIFY_FULL_NAME}
              value={searchActions.SHOPIFY_FULL_NAME}
              disabled={isZendeskShopSelected}
            >
              Get shopify orders by 'firstname lastname'
            </option>,
          ]}
        {isAmazonInstalled && [
          <option key={searchActions.AMAZON_EMAIL} value={searchActions.AMAZON_EMAIL}>
            Get amazon orders by email
          </option>,
          <option key={searchActions.AMAZON_ORDER_NUMBER} value={searchActions.AMAZON_ORDER_NUMBER}>
            Get amazon order by number
          </option>,
        ]}
        {isZendeskShopSelected && [
          <option key={searchActions.ZENDESK_EMAIL} value={searchActions.ZENDESK_EMAIL}>
            Get orders by email
          </option>,
          <option key={searchActions.ZENDESK_ORDER_NUMBER} value={searchActions.ZENDESK_ORDER_NUMBER}>
            Get order by number
          </option>,
          <option key={searchActions.ZENDESK_EBAY_USERNAME} value={searchActions.ZENDESK_EBAY_USERNAME}>
            Get orders by eBay username
          </option>,
          <option key={searchActions.ZENDESK_FULL_NAME} value={searchActions.ZENDESK_FULL_NAME}>
            Get orders by full name
          </option>,
        ]}
        {isCustomSellerInstalled && [
          <option key={searchActions.CUSTOM_SELLER_EMAIL} value={searchActions.CUSTOM_SELLER_EMAIL}>
            Get order by email
          </option>,
        ]}
        {isSimplrOrderInstalled && [
          <option key={searchActions.SIMPLR_ORDER_EMAIL} value={searchActions.SIMPLR_ORDER_EMAIL}>
            Get simplr order by email
          </option>,
          <option key={searchActions.SIMPLR_ORDER_ID} value={searchActions.SIMPLR_ORDER_ID}>
            Get simplr order by order number
          </option>,
          <option key={searchActions.SIMPLR_ORDER_PHONE_NUMBER} value={searchActions.SIMPLR_ORDER_PHONE_NUMBER}>
            Get simplr order by phone number
          </option>,
          <option key={searchActions.SIMPLR_ORDER_CUSTOMER_NAME} value={searchActions.SIMPLR_ORDER_CUSTOMER_NAME}>
            Get simplr order by customer name
          </option>,
          <option key={searchActions.SIMPLR_ORDER_CUSTOMER_ID} value={searchActions.SIMPLR_ORDER_CUSTOMER_ID}>
            Get simplr order by customer id
          </option>,
        ]}
        {isRbiInstalled && [
          <option key={searchActions.RBI_EMAIL} value={searchActions.RBI_EMAIL}>
            Get RBI order by email
          </option>,
          <option key={searchActions.RBI_ID} value={searchActions.RBI_ID}>
            Get RBI order by order number
          </option>,
        ]}
        {isSalesforceOrderManagerEnabled && [
          <option key={searchActions.SALESFORCE_ORDER_EMAIL} value={searchActions.SALESFORCE_ORDER_EMAIL}>
            Get salesforce order by email
          </option>,
          <option key={searchActions.SALESFORCE_ORDER_ID} value={searchActions.SALESFORCE_ORDER_ID}>
            Get salesforce order by order id
          </option>,
        ]}
      </SearchPageSelect>
    );
  }

  getSelectedMultiDomain = () => {
    switch (this.props.orderingSystem) {
      case 'simplrOrder':
        return this.props.simplrOrderMultiDomains[0];
      default:
        return this.props.multiDomain;
    }
  };

  renderSearchBox() {
    const { defaultSearchValue, defaultSearchValueType, needToShowOnlySearchButton } = this.props;

    return (
      <SearchOrdersBox>
        <div style={{ flexBasis: '50%' }}>{this.getSelectOptions()}</div>
        {this.showMultiShopSelect() && (
          <div style={{ flexBasis: '50%' }}>
            <SearchPageSelect onChange={this.handleDomainSelection} value={this.getSelectedMultiDomain()}>
              {this.getMultiShopSelect().map((domain) => (
                <option value={domain.value} key={domain.value}>
                  {domain.name}
                </option>
              ))}
            </SearchPageSelect>
          </div>
        )}
        <div style={{ flexBasis: '50%' }}>
          {needToShowOnlySearchButton ? (
            <FullColoredButton active onClick={() => this.handleSearchOrders('No-keyword orders')}>
              Search
            </FullColoredButton>
          ) : (
            <SearchInput
              placeholder="Search keywords"
              messageImg={false}
              onClickFunction={this.handleSearchOrders}
              defaultValue={defaultSearchValue}
              defaultValueType={defaultSearchValueType}
            />
          )}
        </div>
      </SearchOrdersBox>
    );
  }

  renderResults() {
    const { ordersSearch, orderingSystem, isZendeskShopSelected } = this.props;

    if (ordersSearch.orders && !ordersSearch.orders.length) {
      return (
        <NoSearchResults
          title={'No orders matched your search!'}
          subTitle={'Make sure you are searching with the correct customer information.'}
        />
      );
    } else if (ordersSearch.orders) {
      const selectedStore = ordersSearch.searchOrderShops && ordersSearch.searchOrderShops[0];
      const searchOrderZendeskConfig =
        selectedStore && ordersSearch.searchOrderZendeskConfig && ordersSearch.searchOrderZendeskConfig[selectedStore];

      const zendeskConfig = {
        isZendesk: isZendeskShopSelected,
        returnUrl: (searchOrderZendeskConfig || {}).returnUrl || '',
        customMessage: (searchOrderZendeskConfig || {}).customMessage || '',
      };

      return (
        <SearchAndResults>
          <ResultsBox>
            <Table>
              <SearchResultHeader
                listType={searchTypes.SEARCH_ORDERS}
                zendeskConfig={zendeskConfig}
                orderingSystem={orderingSystem}
              />
              <SearchResultList
                listType={searchTypes.SEARCH_ORDERS}
                resultList={ordersSearch.orders}
                resultClickAction={this.selectClickHandler()}
                zendeskConfig={zendeskConfig}
                orderingSystem={orderingSystem}
              />
            </Table>
          </ResultsBox>
        </SearchAndResults>
      );
    }
  }

  render() {
    const results = this.renderResults();
    const displayForSearch = results ? results : <SearchIntro />;

    return this.state.fetchingOrder ? (
      <LoadingContainer name="LoadingContainer">
        <Loading delay={0} label="Load order details" marginTop={'0px'} />
      </LoadingContainer>
    ) : (
      <SearchOrdersPageWrapper name="SearchOrdersPageWrapper">
        <BlueSection border={true}>{this.renderSearchBox()}</BlueSection>
        {this.props.loading ? (
          <LoadingContainer>
            <Loading delay={0} marginTop={'0px'} />
          </LoadingContainer>
        ) : (
          displayForSearch
        )}
      </SearchOrdersPageWrapper>
    );
  }
}

function mapStateToProps(state) {
  const loading = state.ui.loading.isLoading && state.ui.loading.component === 'searchPage';

  return {
    loading,
    rbiDomains: getRbiDomains(state),
    simplrorderDomains: getSimplrorderDomains(state),
    simplrorderConfigs: getSimplrorderConfigs(state),
    multiDomain: getSelectedMultiDomain(state),
    simplrOrderMultiDomains: getSelectedSimplrOrderMultiDomains(state),
    selectedTicket: extractSelectedTicketFromState(state) || {},
    firstMessage: extractFirstMessage(state),
    ordersSearch: getOrdersSearchProperties(state),
    orderingSystem: getOrderingSystem(state),
    isShopifyInstalled: getIsShopifyInstalled(state),
    isSimplrOrderInstalled: getIsSimplrOrderInstalled(state),
    isRbiInstalled: getIsRbiInstalled(state),
    isSalesforceOrderManagerEnabled: getIsSalesforceOrderManagerEnabled(state),
    isAmazonInstalled: getIsAmazonInstalled(state),
    isCustomSellerInstalled: getIsCustomSellerInstalled(state),
    isZendeskShopSelected: getIsZendeskShopSelected(state),
    selectedSearchAction: getSelectedOrderSearchAction(state),
    defaultSearchValue: chooseDefaultSearchValue(state),
    defaultSearchValueType: getDefaultSearchValueType(state),
    isSpecialist: state.user.isAdmin,
    isIntegrationValueAvailable: isIntegrationValueAvailable(state),
  };
}

const mapDispatchToProps = (dispatch) => ({
  setLoading: (isLoading) => {
    return dispatch(setLoading(isLoading, 'searchPage'));
  },
  ...bindActionCreators(
    {
      shopifyGetOrder,
      setSelectedMultiDomain,
      setSimplrOrderSelectedMultiDomains,
      shopifyGetCustomerOrders,
      shopifyGetAndSelectOrder,
      amazonGetOrderByNumber,
      searchRbiOrdersByEmail,
      searchRbiOrdersById,
      searchSalesforceOrdersByEmail,
      searchSalesforceOrdersById,
      amazonGetOrdersByEmail,
      getCustomerOrdersFromZendesk,
      getOrderByCustomSellerEmail,
      selectOrder,
      setSelectedTicketOrderNumber,
      selectOrderingSystem,
      setSearchOrdersAction,
      simplrOrderGetOrdersById,
      simplrOrderGetOrders,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchOrders);
